/** 画面の HUD に出すための固定長ログ。console にも流す。 */
export class RingLog {
  private readonly buf: string[] = [];
  constructor(private readonly capacity = 50, private readonly onLine?: (line: string) => void) {}

  push(msg: string): void {
    const line = `${new Date().toLocaleTimeString('ja-JP', { hour12: false })} ${msg}`;
    this.buf.push(line);
    while (this.buf.length > this.capacity) this.buf.shift();
    console.log('[app]', msg);
    this.onLine?.(line);
  }

  lines(): string[] {
    return [...this.buf];
  }

  get size(): number {
    return this.buf.length;
  }
}
